import { useState } from "react";
import { Button, EmptyState, useLanguage, useT, type MessageKey } from "@mmm/ui";
import { listCreditTransactions } from "../../api/queries.js";
import { useQuery } from "../../api/useQuery.js";
import { ListRow } from "../molecules/ListRow.js";

const PAGE_SIZE = 25;
const SOURCE_LABELS: Record<string, MessageKey> = {
  purchase: "credits.purchase",
  usage: "credits.usage",
  practiceUsage: "credits.usage",
  translationReward: "credits.translationReward",
  translationReviewReward: "credits.translationReward",
  referralReward: "credits.referralReward",
  starter: "credits.starter",
  refund: "credits.refund",
};

export function CreditHistory() {
  const t = useT();
  const { language } = useLanguage();
  const [offset, setOffset] = useState(0);
  const result = useQuery(listCreditTransactions, { offset, limit: PAGE_SIZE });
  const number = new Intl.NumberFormat(language, { signDisplay: "always" });
  const date = new Intl.DateTimeFormat(language, { dateStyle: "medium" });
  return <section aria-label={t("credits.activityTitle")}>
    <h3>{t("credits.activityTitle")}</h3>
    {!!result.error && <p role="alert">{t("credits.unavailable")}</p>}
    {!result.error && result.loading && <p>{t("common.loading")}</p>}
    {!result.error && result.data?.items.length === 0 && <EmptyState variant="list" title={t("credits.noActivityTitle")} message={t("credits.noActivityMessage")} />}
    {result.data?.items.map((item) => <ListRow key={item.id}
      title={t(SOURCE_LABELS[item.source] ?? "credits.adjustment")}
      meta={date.format(new Date(item.createdAt))}
      trailing={<span>{number.format(item.amount)}</span>}
    />)}
    {result.data?.hasMore && <Button variant="secondary" onClick={() => setOffset((value) => value + PAGE_SIZE)}>{t("credits.nextPage")}</Button>}
    {offset > 0 && <Button variant="secondary" onClick={() => setOffset((value) => Math.max(0, value - PAGE_SIZE))}>{t("credits.previousPage")}</Button>}
  </section>;
}
